import { render, staticRenderFns } from "./Solicitacoes.vue?vue&type=template&id=5a0ac3f8&scoped=true&"
import script from "./Solicitacoes.vue?vue&type=script&lang=js&"
export * from "./Solicitacoes.vue?vue&type=script&lang=js&"
import style0 from "./Solicitacoes.vue?vue&type=style&index=0&id=5a0ac3f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0ac3f8",
  null
  
)

export default component.exports